export default __webpack_public_path__ + "static/media/PositiveRunningMidstance.1b61d44d.png";